import yup from "src/validators/yup.Module";

export interface TributacaoCfopImpostoCadastroDto {
  id: number;
  tributacaoCFOPId: number;
  tipoImposto: number;
  tipoImpostoDescricao: string;
  cst: number;
  aliquotaSimples: number;
}

export const TributacaoCfopImpostoCadastroSchema = yup.object().shape({
  cst: yup.number().when("tipoImposto", {
    is: (tipoImposto: number) => tipoImposto === 0,
    then: (schema) =>
      schema
        .required("CST/CSOSN é obrigatório")
        .min(1, "Seleciona uma CST/CSOSN válida"),
    otherwise: (schema) => schema.notRequired(),
  }),
  aliquotaSimples: yup
    .number()
    .nullable()
    .when(["tipoImposto", "cst"], {
      is: (tipoImposto: number, cst: number) =>
        tipoImposto === 0 && cst === 101,
      then: (schema) =>
        schema
          .required("Alíquota Simples é obrigatória")
          .min(0.01, "Alíquota deve ser maior que zero"),
      otherwise: (schema) => schema.notRequired(),
    }),
});

export type cst = {
  value?: string;
  label: string;
};

export const getCstOptions = (type: string | null) => {
  if (type === "0") {
    //ICMS
    return [
      { value: 0, label: "Selecione" },
      {
        value: 101,
        label: "101-Tributação ICMS pelo Simples Nacional",
      },
      {
        value: 102,
        label: "102-Tributada pelo Simples Nacional sem permissão de crédito",
      },
      {
        value: 103,
        label:
          "103-Isenção do ICMS no Simples Nacional para faixa de receita bruta",
      },
      { value: 300, label: "300-Imune" },
      {
        value: 400,
        label: "400-Não tributada pelo Simples Nacional",
      },
      {
        value: 500,
        label: "500-ICMS cobrado anteriormente por substituição tributária",
      },
    ];
  } else if (type === "1") {
    //IPI
    return [
      { value: -1, label: "Selecione" },
      { value: 0, label: "00 - Entrada com recuperação de crédito" },
      { value: 1, label: "01 - Entrada tributada com alíquota zero" },
      { value: 2, label: "02 - Entrada isenta" },
      { value: 3, label: "03 - Entrada não-tributada" },
      { value: 4, label: "04 - Entrada imune" },
      { value: 5, label: "05 - Entrada com suspensão" },
      { value: 49, label: "49 - Outras entradas" },
      { value: 50, label: "50 - Saída tributada" },
      { value: 51, label: "51 - Saída tributada com alíquota zero" },
      { value: 52, label: "52 - Saída isenta" },
      { value: 53, label: "53 - Saída não-tributada" },
      { value: 54, label: "54 - Saída imune" },
      { value: 55, label: "55 - Saída com suspensão" },
      { value: 99, label: "99 - Outras saídas" },
    ];
  } else if (type === "2" || type === "3") {
    //PIS e COFINS
    return [
      { value: 0, label: "Selecione" },
      { value: 1, label: "01 - Operação Tributável com Alíquota Básica" },
      {
        value: 2,
        label: "02 - Operação Tributável com Alíquota Diferenciada",
      },
      {
        value: 3,
        label:
          "03 - Operação Tributável com Alíquota por Unidade de Medida de Produto",
      },
      {
        value: 4,
        label: "04 - Operação Tributável Monofásica - Revenda a Alíquota Zero",
      },
      {
        value: 5,
        label: "05 - Operação Tributável por Substituição Tributária",
      },
      { value: 6, label: "06 - Operação Tributável a Alíquota Zero" },
      { value: 7, label: "07 - Operação Isenta da Contribuição" },
      { value: 8, label: "08 - Operação sem Incidência da Contribuição" },
      { value: 9, label: "09 - Operação com Suspensão da Contribuição" },
      { value: 99, label: "99 - Outras Operações" },
    ];
  } else {
    return [{ label: "Selecione" }];
  }
};
